import { render, staticRenderFns } from "./Level.vue?vue&type=template&id=87b12a6e&scoped=true&"
import script from "@/views/Levels/Level.ts?vue&type=script&lang=ts&"
export * from "@/views/Levels/Level.ts?vue&type=script&lang=ts&"
import style0 from "@/views/Levels/level.scss?vue&type=style&index=0&id=87b12a6e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87b12a6e",
  null
  
)

export default component.exports